<button class="icon-btn" *ngIf="!active" (click)="activate()">
  <img src="/assets/img/icons/icon-add-campaign.svg" />
  <p>{{ 'Create campaign' | translate }}</p>
</button>
<ng-container *ngIf="active">
  <button
    class="icon-btn poi-menu-toggle"
    *ngIf="!open"
    (click)="open = true"
    [class.no-pois]="pois.length === 0"
  >
    <ng-container *ngIf="pois.length === 0">
      <img src="/assets/img/brands/asset/logo.svg" />
      <p>{{ 'select POIs' | translate }}...</p>
    </ng-container>
    <ng-container *ngIf="pois.length > 0">
      <img src="/assets/img/icons/icon-poi-selected.svg" />
      <p>{{ pois.length }} POIs</p>
    </ng-container>
  </button>
  <div class="poi-menu" *ngIf="open">
    <header class="flex">
      <p>{{ 'Campaign POIs' | translate }}</p>
      <button (click)="open = false">
        <img src="/assets/img/icons/positive-clear/close.svg" />
      </button>
    </header>
    <!-- <div class="flex top-tools">
      
    </div> -->
    <div class="flex">
      <div class="poi-upload-wrapper">
        <label for="poi-upload" class="icon-btn">
          <img src="/assets/img/icons/icon-upload.svg" />
          <p>{{ 'Upload CSV' | translate }}</p>
        </label>
        <input
          #poiUploadInput
          type="file"
          id="poi-upload"
          name="poi-upload"
          accept="text/csv"
          (change)="uploadPOIs(poiUploadInput)"
        />
      </div>
      <div (appClickOutside)="dropdownOpen = false" class="action-menu">
        <button
          class="action-menu-trigger icon-btn"
          (click)="dropdownOpen = !dropdownOpen"
        >
          <p>{{ 'Actions' | translate }}</p>
          <img
            src="/assets/img/icons/secondary/arrow-dropdown.svg"
            alt="arrow dropdown icon"
          />
        </button>
        <ul class="action-menu-list" [class.open]="dropdownOpen">
          <button class="all-btn" (click)="selectAll(); dropdownOpen = false">
            <p>{{ 'Select all filtered POIs' | translate }}</p>
          </button>
          <button class="remove-btn" (click)="clear(); dropdownOpen = false">
            <p>{{ 'Remove all' | translate }}</p>
          </button>
        </ul>
      </div>
    </div>
    <ul class="poi-list">
      <li *ngFor="let id of pois">
        <button class="flex" (click)="removeSinglePOI(id)">
          <p>{{ getPOIName(id) }}</p>
          <img src="/assets/img/icons/positive-clear/delete.svg" />
        </button>
        <p class="poi-address">{{ poiAddressMap[id] }}</p>
      </li>
      <!-- <cdk-virtual-scroll-viewport class="poi-list" itemSize="51">
        <li *cdkVirtualFor="let poi of pois">
          <button class="flex" (click)="removeSinglePOI(poi)">
            <p>POI {{ formatID(poi) }}</p>
            <img src="/assets/img/icons/positive-clear/delete.svg" />
          </button>
          <p class="poi-address">{{ poiAddressMap[poi] }}</p>
        </li>
      </cdk-virtual-scroll-viewport> -->
    </ul>
    <footer>
      <p>
        <ng-container *ngIf="!allPoisSelected">
          <strong>{{ pois.length }} POIs · </strong>
        </ng-container>
        <span>{{ totalReach | number : '1.0' }} </span>
        <small> {{ 'Total Reach' | translate }}</small>
      </p>
      <div class="flex">
        <button class="discard-btn" (click)="discard()">
          <p>{{ 'Discard' | translate }}</p>
        </button>
        <button class="confirm-btn" (click)="confirm()">
          <p>{{ 'Finish campaign' | translate }}</p>
        </button>
      </div>
    </footer>
  </div>
</ng-container>
